import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppComponent } from "./app.component";
import { AppConfig } from "./app.config";
import { AppData } from "./app.data";
import { AppRoutingModule, guards, pages } from "./app.routing.module";
import { SharedModule } from "./shared/shared.module";
import { ajax, css } from "jquery";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

@NgModule({
    imports: [
    BrowserModule,
    BrowserAnimationsModule,
        SharedModule.forRoot(),
        AppRoutingModule
    ],
    declarations: [
        AppComponent,
        pages
    ],
    providers: [
        AppConfig, AppData, guards,
        {
            provide: APP_INITIALIZER,
            useFactory: (config: AppConfig) => () => config.load(),
            deps: [AppConfig],
            multi: true
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
